import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full block cursor-pointer hover:bg-gray-200 focus:outline-none focus:bg-gray-200 transition duration-150 ease-in-out" }
const _hoisted_2 = { class: "flex items-center px-4 py-4 sm:px-6" }
const _hoisted_3 = { class: "min-w-0 flex-1 flex items-center" }
const _hoisted_4 = { class: "text-sm leading-5 font-medium truncate" }
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "gray",
  "aria-label": "delete"
}, [
  /*#__PURE__*/_createVNode("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  })
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("li", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.todo.task), 1)
      ]),
      _createVNode("div", null, [
        _createVNode("input", {
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.updateTaskCompletion(_ctx.todo, !_ctx.todo['is_complete']))),
          class: "cursor-pointer",
          type: "checkbox",
          checked: _ctx.todo['is_complete']
        }, null, 8, ["checked"])
      ]),
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.clearTodo(...args))),
        class: "w-4 h-4 ml-2 border-2 hover:border-black rounded"
      }, [
        _hoisted_5
      ])
    ])
  ]))
}